document.addEventListener('submit', async (event) => {

  const form = event.target.closest('.jh-card-quick-add');

  if (!form) return;

  event.preventDefault();

  const button = form.querySelector('.jh-card-quick-add__button');

  if (!button) return;

  const formData = new FormData(form);

  button.disabled = true;

  const originalText = button.textContent;

  button.textContent = 'Adding...';

  try {

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Cart error');
    }

    button.textContent = 'Added ✓';

    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1500);

  } catch (error) {

    button.textContent = 'Error';

    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1500);

  }

});